import axios from "axios";
import { getToken } from "../utils/auth";

const enableLogs = process.env.REACT_APP_ENABLE_API_LOGS === "true" || process.env.NODE_ENV === "development";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  
  // Connection request logging
  if (enableLogs) {
    console.log(`[API Outgoing Connection] ${config.method?.toUpperCase()} Request to: ${config.baseURL || ''}${config.url || ''}`);
  }
  return config;
});

api.interceptors.response.use(
  (response) => {
    if (enableLogs) {
      console.log(`[API Connection Success] Received: ${response.status} from ${response.config.url}`);
    }
    return response;
  },
  (error) => {
    if (enableLogs) {
      console.error(`[API Connection Error] Connection failed:`, error.message || error);
    }
    return Promise.reject(error);
  }
);

export default api;
